module.exports = __webpack_public_path__ + "static/media/add-users.2161ff32.png";